/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React, { Component } from 'react';
// Load locale-specific relative date/time formatting rules.
import { withConfigContext } from '../../../../../../components/ConfigContext';
import { withTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import TopGroups from './TopGroups';
import TreeHierarchy from './TreeHierarchy';

const { TabPane } = Tabs;

class GroupView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      childrenGroups: [],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters !== this.props.filters) {
      this.setState({ activeTab: '1' });
    }
  }

  handleTabChange = key => {
    this.setState({ activeTab: key });
  };

  render() {
    const { t, filters } = this.props;
    const { activeTab, children } = this.state;
    const tab = 'group';

    return (
      <Tabs
        defaultActiveKey="1"
        activeKey={activeTab}
        onChange={this.handleTabChange}
      >
        <TabPane tab={t('home_menu_groups')} key="1">
          {/* eslint-disable-next-line react/no-children-prop */}
          <TopGroups children={children} tab={tab} filters={filters} />
        </TabPane>
        <TabPane tab={t('label_hierarchical_view')} key="2">
          <TreeHierarchy />
        </TabPane>
      </Tabs>
    );
  }
}
export default withConfigContext(withTranslation()(GroupView));
